import object from 'helpers/object'


export const initialState = []


export const set = (state, payload) =>
  payload
